import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import "./rolesDropdown.css";

const RolesDropdown = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const options = [
    { value: "habitat editor", label: "Habitat Editor" },
    { value: "channel partner", label: "Channel Partner" },
    { value: "referral", label: "Referral" },
    // { value: "rent owner", label: "Rent Owner" },
  ];

  const selectedOption = options.find((opt) => opt.value === value);

  const handleSelect = (optionValue) => {
    onChange({ target: { value: optionValue } }); 
    setIsOpen(false);
  };

  return (
    <div className="psd-wrapper">
      <button
        className="psd-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className="psd-label">{selectedOption?.label ?? "All"}</span>
        <ChevronDown size={18} className={`psd-chevron ${isOpen ? "open" : ""}`} />
      </button>

      {isOpen && (
        <div className="psd-menu">
          {options.map((option) => (
            <button
              key={option.value}
              className={`psd-option ${value === option.value ? "active" : ""}`}
              onClick={() => handleSelect(option.value)}
            >
              <span className="psd-option-label">{option.label}</span>
              {value === option.value && <span className="psd-checkmark">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default RolesDropdown;